export enum enTermOrigin {
  course = 'course',
  lesson = 'lesson'
}
export interface TermProps {
  lessonId?: string;
  origin: enTermOrigin;
}
